import React, { useState, useEffect } from 'react';
import { EaseTable } from '../../../libs/EaseTable';
import { isMobile } from 'react-device-detect';
import { MerchantService } from "../../../services";
import { TallyInvoice, BulkUploadBatch } from '../../../models';
import { handleApiExceptions, generate_query_set, alertify } from '../../../app_methods';
import { getTallyInvoiceTableColumns, tallyInvoiceFilterNodes } from './constants';
import { TallyInvoiceDetails } from './details';
import { ContentCard } from '../../Common';
import { connect } from 'react-redux';
import { Empty, Button, Alert } from "antd";
import { updateCurrentUserAction } from "../../../redux/actions";

// import { CreatePermissionHoc, PermissionHoc } from '../../HOC';
import { PermissionHoc } from '../../HOC';
import FileSaver from 'file-saver';

const tallyInvoice = new TallyInvoice();
const TallyInvoiceList = (props) => {
    const [invoices, setInvoices] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDownloading,setIsDownloading]= useState(false);

    const [pagination, setPagination] = useState({
        pageSize: 10,
        total: 0,
        current: 1,
        showSizeChanger: true,
        pageSizeOptions: ["10", "25", "50", "100"],
        showTotal: (total) => `Total ${total} Records`
    });
    const [filters, setFilters] = useState({});
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [showTallyInvoiceDetailsDrawer, setShowTallyInvoiceDetailsDrawer] = useState(false);
    const [selectedTallyInvoice, setSelectedTallyInvoice] = useState({});

    const PermissableButton = PermissionHoc(Button, null, { is_component: true, fallbackComponent: null })

    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const toggleTallyInvoiceDetailsDrawer = (obj = {}) => {
        setSelectedTallyInvoice(obj);
        setShowTallyInvoiceDetailsDrawer(!showTallyInvoiceDetailsDrawer);
    };

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchTransfers(_pagination, tableInfo.filters);
    };

    const handleRowSelection = (selectedRows) => {
        setSelectedInvoices(selectedRows);
    };

    const fetchTransfers = async (_pagination = pagination, _filters = filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = _filters.batch_id ?
            await BulkUploadBatch.fetch_transfers({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) })
            :
            await TallyInvoice.list({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) })
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        let queryset = generate_query_set(TallyInvoice, response.data.results)
        // queryset = queryset.map((invoice) => { return { ...invoice, is_submerchant:!!_filters.submerchant_id, submerchant: _filters.submerchant_id}})
        setInvoices(queryset);
        setPagination({ ...pagination, total: response.data.count });
        setIsTableLoading(false);
    };

    const initiateTransfer = async (data = {}) => {
        setIsLoading(true);
        const response = await tallyInvoice.initiate(data);
        if (!response.success) {
            setSelectedInvoices([])
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }        
        setIsLoading(false);
        
        if (response.data.success){
            alertify("Success", response.data.message, "success");
            setSelectedInvoices([])
            fetchTransfers(pagination,filters);
        } else{
            alertify("Error", response.data.message, "error");
            setSelectedInvoices([])
            fetchTransfers(pagination,filters);
        }
    }

    const startTransfer = () => {
        var invoice_ids = selectedInvoices.map(function(i) {
            return i.id;
        });
        var data = {invoices:invoice_ids}
        initiateTransfer(data)
    } 

    const tableColumns = getTallyInvoiceTableColumns({toggleTallyInvoiceDetailsDrawer})
    // const tableFilters = tallyInvoiceFilterNodes(props.current_user);
    const tableFilters = tallyInvoiceFilterNodes();

    const onSubmit = async (e) => {
        setIsSaving(true);
        let response = await MerchantService.generate_tally_credentials();
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            return;
        }
        if (response.data.success){
            alertify("Success", response.data.message, "success");
        } else {
            alertify("Error", response.data.message, "error");
        }
        setIsSaving(false);
        fetchMerchantInfo()
    };

    const downloadReport = async () => {
        setIsDownloading(true);
        const response = await TallyInvoice.download_report({ ...prepFilters(filters) });
        if (response.status != 200) {
            setIsDownloading(false);
            handleApiExceptions("Something went wrong !");
            return;
        }
        FileSaver.saveAs(response.data, `Tally Invoice Report.csv`);
        setIsDownloading(false);
    };

    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };
    
    useEffect(() => {
        props.onChildMount();
        let defaultFilters = {};
        tableFilters ??[].forEach(f => defaultFilters[f.field] = f.defaultValue);
        setFilters({ ...filters, ...defaultFilters });
        fetchTransfers(pagination, { ...filters,  ...defaultFilters });
    }, []);

    return (
        props.current_user?.etiv ? (
        <ContentCard className="p-3">
            <div className="w-100 d-flex justify-content-end">
                {/* <Button type="primary" onClick={startTransfer} loading={isLoading} disabled={selectedInvoices.length && !filters.submerchant_id ? false : true} >Pay</Button> */}
                <PermissableButton required_permission="TALLY_INVOICES_WRITE" type="primary" onClick={startTransfer} loading={isLoading} disabled={selectedInvoices.length ? false : true} >Pay</PermissableButton>
            </div>
            <EaseTable
                rowKey="id"
                loading={isTableLoading}
                data={invoices}
                columns={tableColumns}
                fixedSelectable={!isMobile}
                selectable={true}
                selectedRows={selectedInvoices}
                handleTableChange={handleTableChange}
                handleRowSelection={handleRowSelection}
                pagination={pagination}
                totalRecords={pagination.total}
                filterNodes={tableFilters}
                emptyText={
                    !(props.current_user.tally_credentials && props.current_user.tally_credentials.tally_account_email)? 
                    <Empty description={<span>Generate your Tally credentials in order to start syncing invoices.</span>}>
                        <PermissableButton required_permission="TALLY_INVOICES_WRITE" onClick={onSubmit} loading={isSaving}>Generate Tally Credentials</PermissableButton>
                    </Empty>
                    : 'No Data'
                }
                disabledCheckboxProps={(record) => record.status === 'paid' || record.is_attempt_inprocess}
                downloadable={true}
                onDownload={downloadReport}
            />
            <TallyInvoiceDetails
                visible={showTallyInvoiceDetailsDrawer}
                onClose={toggleTallyInvoiceDetailsDrawer}
                payoutLink={selectedTallyInvoice}
            />
        </ContentCard> 
    ) : <Alert message="Error" description="You are not authorised to view this page." type="error" showIcon />
)}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});


const mapDispatchToProps = (dispatch) => ({
	updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

// export default connect(mapStateToProps, mapDispatchToProps)(TallyInvoiceList);
export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(TallyInvoiceList,'TALLY_INVOICES_READ'));